import {
  Button,
  Form,
  Layout,
  Space,
  Spin,
  Steps,
  Typography,
  message,
} from "antd";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import APIService from "../Api/api.service";
import Document from "../components/3rpartyrequest/bulkrequest/documents";
import RecordRelease from "../components/3rpartyrequest/bulkrequest/recordrelease";
import RequesterInformation from "../components/3rpartyrequest/bulkrequest/requesterinformation";
import { ThemeContext } from "../context/themeContext";
import Facility from "../components/3rpartyrequest/singlerequest/facility";
import CustomHeader from "../components/common/Header";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../constants/Route";
import {LOGO_SVG_URL } from "../constants/common";


const FormItemLayout = {
  labelCol: {
    xl: {
      span: 24,
    },
  },
  wrapperCol: {
    xl: {
      span: 24,
    },
  },
};

const BulkRequest = () => {
  const { t, i18n } = useTranslation();
  const { theme } = useContext(ThemeContext)
  const navigate = useNavigate(); // Hook for navigation
  const [current, setCurrent] = useState(0);
  const { Content, Footer, Header } = Layout;
  const [form] = Form.useForm();
  const [apiservice] = useState(() => new APIService());
  const [loading, setLoading] = useState(false);
  const [defaultFile, setDefaultFile] = useState({});
  const [fileSizeError, setFileSizeError] = useState(false);

  const [bulkRequestData, setbulkRequestData] = useState({
    RequesterName: "",
    RequesterLastName: "",
    RequesterFaxNumber: "",
    RequesterPhoneNumber: "",
    RequesterEmail: "",
    RequesterAddLine1: "",
    RequesterAddLine2: "",
    RequesterCity: "",
    RequesterState: "",
    RequesterZipCode: "",
    RecordMethod: "",
    RecordMethodReleaseFaxNumber: "",
    useRequesterInformation: false,
    RecordName: "",
    RecordMethodReleaseName: "",
    RecordMethodReleaseEmail: "",
    RecordPhoneNumber: "",
    RecordEmail: "",
    RecordFaxNumber: "",
    bulkRequestDocument: [],
    additionalDocuments: [],
    DocumentNotes: "",
    SRFacilityName: "",
    SRFacility_Email: "",
    SRFacilityPhoneNumber: "",
    SRFacilityAddressLine1: "",
    SRFacilityAddressLine2: "",
    SRFacilityCity: "",
    SRFacilityState: "",
    SRFacilityZipCode: "",
    SRFacilityType: "",
    recipientAddress1: "",
    recipientAddress2: "",
    recipientCity: "",
    recipientState: "",
    recipientZipCode: "",
    RequestLanguage:"",
  });
  const getChildData = (value, name) => {
    let res = { ...bulkRequestData, [name]: value };
    setbulkRequestData(res);
  };
  const onsubmit = async () => {
  

    if (fileSizeError) {
      message.error("Please remove files larger than 10MB before submitting.");
      return;
    }

    form
      .validateFields()
      .then(async () => {
        setLoading(true);
        const ThirdPartySingleRequestModel = {
          requesterDetails: {
            requesterName: bulkRequestData.RequesterName.toString(),
            requesterLastName: bulkRequestData.RequesterLastName.toString(),
            requesterPhoneNumber:
              bulkRequestData.RequesterPhoneNumber.toString(),
            requesterEmail: bulkRequestData.RequesterEmail.toString(),
            requesterFaxNumber: bulkRequestData.RequesterFaxNumber.toString(),
            requesterAddressLine1: bulkRequestData.RequesterAddLine1.toString(),
            requesterAddressLine2: bulkRequestData.RequesterAddLine2.toString(),
            requesterCity: bulkRequestData.RequesterCity.toString(),
            requesterState: bulkRequestData.RequesterState.toString(),
            requesterZipCode: bulkRequestData.RequesterZipCode.toString(),
           },
          recordReleaseInformation: {
            methodOfRelease: bulkRequestData.RecordMethod.toString(),
            recordMethodReleaseName:
              bulkRequestData.RecordMethodReleaseName.toString(),
            recordMethodReleaseEmail:
              bulkRequestData.RecordMethodReleaseEmail.toString(),
            recordMethodReleaseFaxNumber:
              bulkRequestData.RecordMethodReleaseFaxNumber.toString(),
            useRequesterInformation: bulkRequestData.useRequesterInformation,
            nameOrganization:
              bulkRequestData.RecordName.toString() != ""
                ? bulkRequestData.RecordName.toString()
                : bulkRequestData.RequesterName.toString(),
            phoneNumber:
              bulkRequestData.RecordPhoneNumber.toString() != ""
                ? bulkRequestData.RecordPhoneNumber.toString()
                : bulkRequestData.RequesterPhoneNumber.toString(),
            email:
              bulkRequestData.RecordEmail.toString() != ""
                ? bulkRequestData.RecordEmail.toString()
                : bulkRequestData.RequesterEmail.toString(),
            fax: bulkRequestData.RecordFaxNumber.toString(),
            recipientAddress1: (form.getFieldValue("recipientAddress1") ?? bulkRequestData.recipientAddress1 ?? "").toString(),
            recipientAddress2: (form.getFieldValue("recipientAddress2") ?? bulkRequestData.recipientAddress2 ?? "").toString(),
            recipientCity: (form.getFieldValue("recipientCity") ?? bulkRequestData.recipientCity ?? "").toString(),
            recipientState: (form.getFieldValue("recipientState") ?? bulkRequestData.recipientState ?? "").toString(),
            recipientZipCode: (form.getFieldValue("recipientZipCode") ?? bulkRequestData.recipientZipCode ?? "").toString(),
          },
          documentUpload: {
            bulkRequestDocument: bulkRequestData.bulkRequestDocument,
            additionalDocuments: bulkRequestData.additionalDocuments,
            additionalNotes: bulkRequestData.DocumentNotes.toString(),
          },
          facilityInformationdtl: {
            FacilityType: bulkRequestData.SRFacilityType.toString(),
            FacilityName: form.getFieldValue("SRfacilityname").toString(),
            FacilityEmail: bulkRequestData.SRFacility_Email.toString(), //form.getFieldValue("Facility_Email") != "undefined" ? form.getFieldValue("Facility_Email").toString() : "",
            FacilityPhoneNumber:
              bulkRequestData.SRFacilityPhoneNumber.toString(), //form.getFieldValue("fphone") != "undefined" ? form.getFieldValue("fphone").toString() : "",
            FacilityAddressLine1:
              bulkRequestData.SRFacilityAddressLine1.toString(), //form.getFieldValue("faddress1").toString(),
            FacilityAddressLine2:
              bulkRequestData.SRFacilityAddressLine2.toString(), //form.getFieldValue("faddress2") != "undefined" ? form.getFieldValue("faddress2").toString() : "",
            FacilityCity: form.getFieldValue("SRfcity").toString(),
            FacilityState: form.getFieldValue("SRfstate").toString(),
            FacilityZipCode: form.getFieldValue("SRfzipcode").toString(),
            Facility_StartDate: null,
            Facility_EndDate: null,
          },
          Token: sessionStorage.getItem("secrateKey"),
          ClientName: sessionStorage.getItem("currentActiveClient"),
          RequestLanguage: i18n.language,
        };
        let secrateKey = sessionStorage.getItem("secrateKey");
        const formData = new FormData();
        formData.append("secrateKeyOnSubmit", secrateKey);
        if (sessionStorage.getItem("secrateKey") != null) {
          let result = await apiservice.postRequest(
            "SavePatientDetails/ThridPatryBulkRequest",
            ThirdPartySingleRequestModel
          );
          if (result.status !== null) {
            if (result == "SUCCESS") {
              setLoading(false);
              navigate(ROUTES.THANKS);
            }
            else if (result == "Failed") {
              setLoading(false);
              message.error(t("common:something_went_wrong_please_try_again"));
            }
          }
        } else {
          setLoading(false);
          message.error(t("common:something_went_wrong_please_try_again"));
        }
      })
      .catch((info) => {
        setLoading(false);
      });
  };

  const onFinish = () => {
    navigate(ROUTES.THANKS);
  };
  const steps = [
    {
      title: t("bulkRequest:requester"),
    },
    {
      title: t("bulkRequest:facility"),
    },
    {
      title: t("bulkRequest:recipient"),
    },
    {
      title: t("bulkRequest:documents"),
    },
  ];

  const next = () => {
    form
      .validateFields()
      .then(() => {
        setCurrent(current + 1);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));
  return (
    <Spin spinning={loading}>
      <Layout className="bg-white">
        <CustomHeader />
        <Content className="p-8">
          <div className="container mx-auto">
            <Steps
              className={theme}
              type="default"
              labelPlacement={"vertical"}
              current={current}
              items={items}
            />
            {current === 0 && (
              <Form
                key={`bulk-step1-${i18n.language}`}
                layout="vertical"
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step1"
              >
                <RequesterInformation getChildData={getChildData} form={form} />
              </Form>
            )}
            {current === 1 && (
              <Form
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step3"
                layout="vertical"
              >
                <Facility form={form} getChildData={getChildData} />
              </Form>
            )}
            {current === 2 && (
              <Form
                key={`bulk-step2-${i18n.language}`}
                layout="vertical"
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step2"
              >
                <RecordRelease
                  getChildData={getChildData}
                  form={form}
                  bulkRequestData={bulkRequestData}
                />
              </Form>
            )}
            {current === 3 && (
              <Form
                key={`bulk-step3-${i18n.language}`}
                layout="vertical"
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step3"
              >
                <Document
                  getChildData={getChildData}
                  form={form}
                  defaultFile={defaultFile}
                  setDefaultFile={setDefaultFile}
                  setFileSizeError={setFileSizeError}
                />
              </Form>
            )}
            <Space className="mt-8 w-full justify-between">
              {current > 0 && (
                <Button
                  type="primary"
                  onClick={() => prev()}
                >
                  {t("common:back")}
                </Button>
              )}
              {current === steps.length - 1 && (
                <Button
                  type="primary"
                  onClick={current === 3 ? onsubmit : next}
                >
                  {t("common:submit")}
                </Button>
              )}
              {!current && (
                <Link to={ROUTES.PARTY_REQUEST}>
                  <Button type="primary" >
                    {t("common:back")}
                  </Button>
                </Link>
              )}
              {current < steps.length - 1 && (
                <Button
                  type="primary"
                  onClick={() => next()}
                >
                  {t("common:next")}
                </Button>
              )}
            </Space>
          </div>
        </Content>
        <Footer className="welcome-footer bg-white">
          <img
          alt="Logo"
            className="m-auto"
            src={window.location.origin + LOGO_SVG_URL}
          />
        </Footer>
      </Layout>
    </Spin>
  );
};

export default BulkRequest;
